<template>
    <div>
        <div class="d-none d-lg-block">
            <HomeFormRicerca 
                :colors="colors" 
                :homepagedata="homepagedata" 
                :formdata="formdata" 
                :selectedValue="selectedValue" 
                @removeselection="removeSelection"
                @showmap="showMap" 
                :cattegorie="homepagedata.categorie" 
                @get-tipologie="getTipologie" 
                @update-prezzi="getPrezzi" 
                :mobile="false" 
                :claim="claim"
            >
            </HomeFormRicerca>
        </div>
        <div class="d-lg-none">
            <MobileBox
                :colors="colors"
                :homepagedata="homepagedata"
                :mobile="true"
                @categoriaChanged="changeCategoria"
            >
            </MobileBox>
            <Mobile-form 
                :colors="colors" 
                :homepagedata="homepagedata" 
                :formdata="formdata" 
                :selectedValue="selectedValue" 
                :mobile="true" 
                :currentsearch="null"
                @removeselection="removeSelection"
                @showmap="showMap"
                @get-tipologie="getTipologie">
            </Mobile-form>
        </div>
    </div>
</template>

<script>
    import HomeCampiForm from "./HomeCampiForm.vue";
    import MobileFormComponent from './MobileFormRicerca.vue';
    import MobileHomeBoxRicerca from './MobileHomeBoxRicerca.vue';
    import {validationMixin} from 'vuelidate'
    export default {
        mixins: [validationMixin],
        components: {
            'HomeFormRicerca': HomeCampiForm,
            'Mobile-form': MobileFormComponent,
            'MobileBox': MobileHomeBoxRicerca
        },
        props: ['claim', 'colors', 'homepagedata'],
        data() {
            return {
                formdata: {
                    contratti: [],
                    filtriAvanzati: [],
                    tipologie: [],
                    zone: [],
                    categorie: [],
                    prezzi: [],
                },
                selectedValue: {
                    contratto: null,
                    tipologie: [],
                    zone: [],
                    categoria: null,
                    geojson: null
                },
            }
        },
        methods: {
            getPrezzi(selected) {
                if (selected) {
                    window.axios
                        .get(window.base_url + 'dropdowns/price-ranges/' + selected.id)
                        .then(res => {
                            this.$set(this.formdata, 'prezzi', res.data.prezzi);
                        });
                }
            },
            getTipologie(selected) {
                let sel;

                this.$set(this.formdata, 'contratti', []);
                this.$set(this.formdata, 'prezzi', []);
                this.$set(this.formdata, 'tipologie', []);
                this.$set(this.formdata, 'filtriAvanzati', []);
                this.$set(this.selectedValue, 'contratto', null);
                this.$set(this.selectedValue, 'tipologie', []);

                if (selected) {
                    sel = selected.id;

                    window.axios.get(window.base_url + 'forms/ricerca/' + sel).then(res => {
                        this.$set(this.formdata, 'tipologie', res.data.data.tipologie);
                        this.$set(this.formdata, 'contratti', res.data.data.contratti);
                        this.$set(this.formdata, 'filtriAvanzati', res.data.data.filtri_avanzati);
                    });
                }
            },
            removeSelection() {
                this.$root.mapselected = null;
                document.getElementById('geojson_desktop').value = '';
                document.getElementById('geojsonmobile').value = '';
                this.$set(this.selectedValue, 'geojson', null);
            },
            changeCategoria(event) {
                this.selectedValue.categoria = event;
            },
            showMap() {
                this.$root.showMap();
                this.$set(this.selectedValue, 'zone', []);
            },
        },
        mounted() {
            this.$set(this.formdata, 'categorie', this.homepagedata.categorie);
            this.$set(this.formdata, 'zone', this.homepagedata.zone);
        },
    }
</script>

<style lang="scss">
    .mainForm {
        padding: 10px;
    }

    #zone {
        .multiselect--active {
            position: absolute;
        }
    }

    #tipologie {
        .multiselect--active {
            position: absolute;
        }
    }

    .title-freq-src {
        color: white;
        font-size: 0.8em
    }

    .frequently-search {
        padding-left: 1.5em;
        padding-right: 1.5em;
        margin-top: 2em;
        text-align: center;
    }

    .frequently-search p {
        color: white !important;
        font-size: 16px;
    }

    .frequently-search strong {
        color: white !important;
    }

    .frequently-search a {
        color: white;
        //font-size: 0.8em
    }

    .mapselected {
        height: 20px;
        margin-right: 10px;
    }

    .label-sele {
        color: white;
    }

    .draw-mobile-btn {
        width: 100%;
    }

    .homepage-slider .mapSearchBtn {
        margin-top: 36px;
        height: 40px;
    }

    .btn-search-ctn {
        min-width: 150px;
        padding: 0px;
    }

    .input-group {
        flex-wrap: inherit !important;
    }

    .remove-btn {
        background-color: var(--primary);
        color: white;
    }
</style>